import EmailLink from "../components/EmailLink";
import styles from "./Barrierefreiheit.module.css";

export default function Privacy() {
  return (
    <main
      id="main-content"
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "40px 20px",
        lineHeight: 1.6,
      }}
    >
      <h1>Datenschutzerklärung</h1>

      <p>
        Wir freuen uns über Ihr Interesse an unserer Website.
      </p>

      <p>
        Der Schutz Ihrer personenbezogenen Daten bei der Erhebung, Verarbeitung und
        Nutzung anlässlich Ihres Besuchs auf unserer Website ist uns ein
        wichtiges Anliegen. Ihre Daten werden im Rahmen der gesetzlichen
        Vorschriften geschützt.
      </p>

      <p>
        Bitte nehmen Sie sich einen Augenblick Zeit und lesen Sie die
        nachstehenden Informationen. Diese geben Ihnen darüber Auskunft, wie wir
        mit Ihren persönlichen Daten umgehen, wie und zu welchem Zweck diese
        Daten verwendet werden, an wen wir diese Daten weitergeben und wie wir
        Ihre persönlichen Daten schützen.
      </p>

      <p>
        Ihre Persönlichkeitsrechte haben bei uns höchste Priorität und wir
        bemühen uns nach besten Kräften, diese Rechte zu schützen und zu
        gewährleisten.
      </p>

      <h2>Verantwortlicher für die Verarbeitung Ihrer personenbezogenen Daten im Sinne der Europäischen Datenschutz-Grundverordnung ist:</h2>

      <address>
        <p>
          <strong>enercity AG</strong>
          <br />
          <strong>DUODay Hannover</strong>
          <br />
          Glockseeplatz 1
          <br />
          30169 Hannover
        </p>

        <p>
          E-Mail: <EmailLink user="duoday-hannover" domain="enercity.de" />
          <br />
          Telefon: <a href="tel:+495114303016" className={styles.link}>+49 511 430 3016</a>
        </p>
      </address>

      <h2>Datenschutzbeauftragter</h2>
      <p>
        Unseren Datenschutzbeauftragten erreichen Sie per Post unter der o. g.
        Adresse mit dem Adresszusatz „Datenschutzmanagement“ oder per E-Mail an
        <EmailLink user="datenschutz" domain="enercity.de" />.
      </p>

      <h2>Erhebung und Verarbeitung von Daten</h2>
      <p>
        Jeder Zugriff auf unsere Website und jeder Abruf einer auf der Website
        hinterlegten Datei werden protokolliert. Die Speicherung dient
        internen systembezogenen und statistischen Zwecken.
      </p>

      <p>Protokolliert werden:</p>
      <ul>
        <li>Name der abgerufenen Datei,</li>
        <li>Datum und Uhrzeit des Abrufs,</li>
        <li>übertragene Datenmenge,</li>
        <li>Meldung über erfolgreichen Abruf,</li>
        <li>verwendetes Betriebssystem,</li>
        <li>Browser und Browsertyp,</li>
        <li>die Internetseite, von der weitergeleitet wurde,</li>
        <li>der Internet-Service-Provider,</li>
        <li>besuchte Seiten und</li>
        <li>anfragende Domain.</li>
      </ul>

      <p>
        Zusätzlich werden die IP-Adressen der anfragenden Rechner protokolliert.
        Der Verantwortliche zieht allerdings keine Rückschlüsse auf eine Person.
      </p>

      <p>
        Diese Daten werden lediglich dafür benötigt, um die Inhalte unserer
        Website richtig anzeigen zu können, um die Inhalte dauerhaft für Sie zu
        optimieren sowie zur Unterstützung von strafrechtlichen Verfolgungen im
        Falle von Hackerangriffen. Die Daten werden auf Grundlage unseres
        berechtigten Interesses hierzu gemäß Art. 6 Abs. 1 UAbs. 1 lit. f)
        DSGVO verarbeitet. Die Verarbeitung der Daten ist für den Betrieb der
        Webseite erforderlich.
      </p>

      <p>
        Die Daten werden gespeichert, solange sie zur Zweckerfüllung benötigt
        werden, und anschließend automatisch gelöscht.
      </p>

      <h2>Betroffenenrechte</h2>
      <p>
        Gemäß Art. 15 DSGVO steht Ihnen ein Recht auf Auskunft über die
        Verarbeitung Ihrer personenbezogenen Daten zu.
      </p>

      <p>
        Ferner steht es Ihnen frei, Ihre Rechte auf Berichtigung, Löschung oder,
        sofern das Löschen nicht möglich ist, auf Einschränkung der Verarbeitung
        und auf Datenübertragbarkeit gemäß der Artikel 16–18, 20 DSGVO geltend
        zu machen. Sollten Sie dieses Recht in Anspruch nehmen wollen, so wenden
        Sie sich bitte an unseren Datenschutzbeauftragten.
      </p>

      <p>
        Weiterhin steht Ihnen das Recht zu, sich jederzeit bei der zuständigen
        Aufsichtsbehörde zu beschweren. Sollten Sie davon ausgehen, dass die
        Verarbeitung Ihrer personenbezogenen Daten nicht unter Einhaltung der
        Datenschutzgesetze erfolgt, würden wir Sie höflich darum bitten, sich mit
        unserem Datenschutzbeauftragten in Verbindung zu setzen.
      </p>

      <p>
        Des Weiteren haben Sie gemäß Art. 21 DSGVO das Recht, jederzeit einer
        Verarbeitung Ihrer personenbezogenen Daten, die auf Grundlage von Art. 6
        Abs. 1 UAbs. 1 lit. e) und f) DSGVO erfolgt, zu widersprechen.
      </p>

      <h2>Schutz der gespeicherten Daten</h2>
      <p>
        Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um
        Ihre uns zur Verfügung gestellten personenbezogenen Daten vor
        Manipulation, Verlust, Zerstörung oder dem Zugriff unberechtigter
        Personen zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend dem
        Stand der Technik fortlaufend verbessert und angepasst. Es ist nicht
        auszuschließen, dass von Ihnen unverschlüsselt übermittelte Daten von
        Dritten während der Übermittlung eingesehen werden können. Es wird
        darauf hingewiesen, dass hinsichtlich der Datenübertragung über das
        Internet (z. B. bei der Kommunikation per E-Mail) keine abschließend
        sichere Übertragung garantiert werden kann. Empfindliche Daten sollten
        daher entweder gar nicht oder nur über eine sichere Verbindung (SSL)
        über das Internet übertragen werden.
      </p>

      <h2>Minderjährigenschutz</h2>
      <p>
        Die Einwilligung zur Verarbeitung personenbezogener Daten kann nur durch
        eine volljährige Person erteilt werden. Für Dienste der
        Informationsgesellschaft ist die Einwilligung eines Kindes mit der
        Vollendung des sechzehnten Lebensjahres gemäß Art. 8 DSGVO zulässig.
      </p>

      <h2>Hosting</h2>
      <p>
        Die Inhalte dieser Website werden bei folgendem Anbieter gehostet:
      </p>

      <p>
        <strong>Microsoft Ireland Operations Limited (Azure Web App Service)</strong>
        <br />
        One Microsoft Place
        <br />
        South County Business Park, Leopardstown
        <br />
        Dublin 18, D18 P521
        <br />
        Irland
      </p>

      <p>
        Die Verwendung von Microsoft erfolgt auf Grundlage von Art. 6 Abs. 1
        UAbs. 1 lit. f) DSGVO. Unser berechtigtes Interesse liegt in der
        zuverlässigen, sicheren und effizienten Bereitstellung unseres
        Online-Angebots. Weitere Informationen können Sie der
        Datenschutzerklärung von Microsoft unter folgendem Link entnehmen:
        <a href="https://www.microsoft.com/de-de/privacy/privacystatement" className={styles.link}>https://www.microsoft.com/de-de/privacy/privacystatement</a>
      </p>

      <h2>E-Mail-Kontakt, Telefon und Handy</h2>
      <p>
        Auf unserer Website ist eine Kontaktaufnahme über die angegebene
        E-Mail-Adresse möglich. Außerdem können Sie uns über die auf der Website
        angegebene Telefon- oder Handynummer kontaktieren. Nehmen Sie diese
        Möglichkeiten wahr, so werden die dabei übermittelten personenbezogenen
        Daten gespeichert und nur zum Zwecke der Bearbeitung und Beantwortung
        Ihrer Anfrage erhoben und verarbeitet.
      </p>

      <p>
        Sollten Sie auf ein mit uns bestehendes Vertragsverhältnis Bezug nehmen
        oder an einem Angebot interessiert sein, werden Ihre personenbezogenen
        Daten zum Zweck der Erfüllung eines Vertrags oder zur Durchführung
        vorvertraglicher Maßnahmen gemäß Art. 6 Abs. 1 UAbs. 1 lit. b) DSGVO
        verarbeitet.
      </p>

      <p>
        In übrigen Fällen werden Ihre personenbezogenen Daten auf Grundlage
        unseres berechtigten Interesses gem. Art. 6 Abs. 1 UAbs. 1 lit. f)
        DSGVO verarbeitet. Unser Interesse besteht dabei in der schnellen und
        zielgerichteten Bearbeitung von Anfragen. Sie haben das Recht,
        jederzeit der Verarbeitung Ihrer personenbezogenen Daten zu
        widersprechen.
      </p>

      <p>
        Eine Weitergabe Ihrer personenbezogenen Daten an externe Dritte erfolgt
        nicht.
      </p>

      <p>
        Eine Übermittlung der von Ihnen bereitgestellten personenbezogenen Daten
        an ein Drittland oder eine internationale Organisation findet nicht statt
        und ist auch nicht in Planung.
      </p>

      <p>
        Ihre personenbezogenen Daten, welche Sie uns mitteilen, werden bei uns
        für die Dauer der Bearbeitung Ihres Anliegens gespeichert und bis zum
        Ablauf der entsprechenden gesetzlichen Fristen aufbewahrt.
      </p>

      <h2>Anmeldung zum DUODay</h2>
      <p>
        Für die Anmeldung zum DUODay stellen wir Unternehmen ein Onlineformular
        über den Dienst Microsoft Forms zur Verfügung. Dabei verarbeiten wir die
        im Formular angegebenen personenbezogenen Daten, insbesondere die
        Kontaktdaten der anmeldenden Person, Angaben zum Unternehmen sowie die
        weiteren für die Planung, Organisation und Durchführung des DUODay
        erforderlichen Informationen.
      </p>

      <p>
        Die Verarbeitung erfolgt zum Zweck der Bearbeitung der Anmeldung, der
        Kontaktaufnahme mit dem teilnehmenden Unternehmen sowie der
        organisatorischen Vorbereitung und Durchführung des DUODay. Soweit die
        Verarbeitung der Anbahnung oder Durchführung eines Vertragsverhältnisses
        mit der betroffenen Person dient, ist Art. 6 Abs. 1 UAbs. 1 lit. b)
        DSGVO die Rechtsgrundlage. Werden Daten von Ansprechpersonen eines
        Unternehmens verarbeitet, erfolgt dies auf Grundlage unseres
        berechtigten Interesses an einer ordnungsgemäßen Organisation und
        Durchführung der Veranstaltung gemäß Art. 6 Abs. 1 UAbs. 1 lit. f)
        DSGVO. Ohne die als erforderlich gekennzeichneten Angaben kann die
        Anmeldung gegebenenfalls nicht bearbeitet werden.
      </p>

      <p>
        Zur Bereitstellung des Formulars nutzen wir Microsoft Forms, einen Dienst
        der Microsoft Ireland Operations Limited, One Microsoft Place, South
        County Business Park, Leopardstown Dublin 18, D18 P521, Irland.
        Microsoft verarbeitet die über das Formular erhobenen personenbezogenen
        Daten im Rahmen der Bereitstellung des Dienstes. Eine darüber hinausgehende
        Weitergabe an Dritte erfolgt nur, soweit dies zur Organisation und
        Durchführung des DUODay erforderlich ist, eine gesetzliche Verpflichtung
        besteht oder Sie zuvor eingewilligt haben.
      </p>

      <p>
        Die Formulardaten werden grundsätzlich innerhalb der EU beziehungsweise
        des EWR gespeichert. Im Rahmen der Bereitstellung und Unterstützung des
        Dienstes kann eine Verarbeitung in Drittländern, insbesondere in den USA,
        jedoch nicht vollständig ausgeschlossen werden.
      </p>

      <p>
        Die Datenübertragung in die USA stützt sich auf die EU-Standardvertragsklauseln,
        zu welchen Sie hier Details einsehen können:
        <a href="https://www.microsoft.com/licensing/docs/view/Microsoft-Products-and-Services-Data-Protection-Addendum-DPA" className={styles.link}>https://www.microsoft.com/licensing/docs/view/Microsoft-Products-and-Services-Data-Protection-Addendum-DPA</a>
      </p>

      <p>
        Microsoft ist gemäß dem "EU-US Data Privacy Framework" (DPF)
        zertifiziert. Dies ist eine Vereinbarung zwischen der Europäischen Union
        und den USA, die sicherstellen soll, dass europäische
        Datenschutzstandards bei der Verarbeitung von Daten in den USA,
        eingehalten werden. Jedes Unternehmen, das die DPF-Zertifizierung
        erhalten hat, verpflichtet sich zur Einhaltung dieser
        Datenschutzstandards. Weitere detaillierte Informationen hierzu finden
        Sie unter folgendem Link:
        <a href="https://www.dataprivacyframework.gov/participant/6474" className={styles.link}>https://www.dataprivacyframework.gov/participant/6474</a>
      </p>

      <p>
        Die im Rahmen der Anmeldung erhobenen personenbezogenen Daten werden
        gelöscht, sobald sie für die Planung, Durchführung und Nachbereitung des
        DUODay nicht mehr erforderlich sind. Gesetzliche Aufbewahrungspflichten
        und sonstige rechtliche Gründe für eine längere Speicherung bleiben
        unberührt. Weitere detaillierte Informationen hierzu finden Sie unter
        folgendem Link:
        <a href="https://support.microsoft.com/de-de/forms/security-and-privacy-in-microsoft-forms" className={styles.link}>https://support.microsoft.com/de-de/forms/security-and-privacy-in-microsoft-forms</a>
      </p>

      <h2>Cookies und vergleichbare Technologien</h2>
      <p>
        Bei der Nutzung unserer Webseite werden Cookies auf Ihrem Endgerät
        gespeichert. Hierbei handelt es sich um Informationen in der Form eines
        Cookie-Namens mit einem dazugehörigen Wert. Gespeichert werden diese
        Informationen in der Regel in Ihrem Browser. Diese Speicherung erfolgt
        bei dauerhaften Cookies (auch Persistent Cookies) bis deren vorher
        festgelegte Lebensdauer abgelaufen ist, bei Sitzungs-Cookies (auch
        Session Cookies) bis Sie den Browser vollständig schließen.
      </p>

      <p>
        Sofern die Speicherung von und der Zugriff auf Cookies für die
        Bereitstellung grundlegender Webseiten-Funktionen erforderlich ist,
        erfolgt dies auf Grundlage von § 25 Abs. 2 Nr. 2 TDDDG sowie unserem
        berechtigten Interesse hierzu gem. Art. 6 Abs. 1 UAbs. 1 lit. f) DSGVO.
        Diese grundlegenden Funktionen umfassen bspw. Log-Ins, Warenkörbe oder
        ein Einwilligungsmanagement. Sie haben das Recht der Verarbeitung auf
        Grundlage von Art. 6 Abs. 1 UAbs. 1 lit. f) DSGVO zu jeder Zeit zu
        widersprechen.
      </p>

      <p>
        In anderen Fällen erfolgt dies auf Grundlage Ihrer Einwilligung gem. §
        25 Abs. 1 TDDDG. Zu diesen Fällen gehören bspw. die Einbindung von
        Drittdiensten zur Medienwiedergabe oder Analyse- und Trackingdienste. Sie
        haben das Recht, Ihre erteilte Einwilligung jederzeit über das
        Einwilligungsmanagement der Webseite zu widerrufen. Die Rechtmäßigkeit
        der Datenverarbeitung bis zum Widerruf bleibt unberührt.
      </p>

      <h2>Eye-Able Assist</h2>
      <p>
        Zur Verbesserung der digitalen Zugänglichkeit und zur barriereärmeren
        Nutzung unserer Website setzen wir die Assistenzsoftware Eye-Able Assist
        ein. Der Dienst ermöglicht es Ihnen, die Darstellung und Bedienbarkeit
        der Website individuell an Ihre persönlichen Bedürfnisse anzupassen.
        Hierzu gehören beispielsweise die Anpassung von Schriftgrößen,
        Kontrasten und Farben sowie weitere unterstützende Darstellungs- und
        Bedienfunktionen.
      </p>

      <p>
        Anbieter des Dienstes ist die Web Inclusion GmbH, Florian-Geyer-Straße
        1, 97076 Würzburg, Deutschland.
      </p>

      <p>
        Bei der Bereitstellung von Eye-Able Assist werden aus technischen
        Gründen Daten der HTTPS-Anfrage verarbeitet. Hierzu können insbesondere
        die IP-Adresse, Informationen zum verwendeten Browser und zum
        Betriebssystem sowie Zeitpunkt und Inhalt der Anfrage gehören. Nach
        Angaben des Anbieters wird die IP-Adresse unmittelbar anonymisiert und zu
        keinem Zeitpunkt vollständig in den Serverprotokollen gespeichert.
      </p>

      <p>
        Eye-Able Assist setzt keine Cookies ein. Die von Ihnen vorgenommenen
        Einstellungen werden ausschließlich im lokalen Speicher Ihres Browsers
        gespeichert. Dadurch können Ihre individuellen Einstellungen auch bei
        einem späteren Besuch der Website wieder zur Verfügung gestellt werden.
        Ein Tracking Ihres Nutzungsverhaltens findet durch Eye-Able Assist nicht
        statt.
      </p>

      <p>
        Die Verarbeitung erfolgt auf Grundlage unseres berechtigten Interesses,
        Ihnen eine möglichst barrierearme, nutzerfreundliche und an
        individuellen Bedürfnissen ausgerichtete Website bereitzustellen, gemäß
        Art. 6 Abs. 1 UAbs. 1 lit. f) DSGVO. Der Zugriff auf den lokalen
        Speicher Ihres Endgeräts ist für die Bereitstellung der von Ihnen
        ausdrücklich gewünschten Assistenzfunktionen erforderlich und erfolgt
        auf Grundlage von § 25 Abs. 2 Nr. 2 TDDDG.
      </p>

      <p>
        Die Software wird über ein Content Delivery Network bereitgestellt. Nach
        Angaben des Anbieters werden hierfür ausschließlich europäische
        Dienstleister eingesetzt. Eine Übermittlung personenbezogener Daten in
        ein Drittland außerhalb der Europäischen Union beziehungsweise des
        Europäischen Wirtschaftsraums ist daher nicht vorgesehen.
      </p>

      <p>
        Eine automatisierte Entscheidungsfindung einschließlich Profiling findet
        nicht statt. Die im lokalen Speicher hinterlegten Einstellungen
        verbleiben auf Ihrem Endgerät und können von Ihnen jederzeit über die
        Einstellungen Ihres Browsers gelöscht werden. Weitere detaillierte
        Informationen hierzu finden Sie unter folgendem Link:
        <a href="https://eye-able.com/de/datenschutz-eye-able" className={styles.link}>https://eye-able.com/de/datenschutz-eye-able</a>
      </p>
    </main>
  );
}
